export const FILTERS_STORAGE_INITIAL_VALUES = {
  name: '',
  setName: () => {},
  filters: {},
  setFilters: () => {},
  saveFilters: () => {},
}
